import { render, staticRenderFns } from "./index.vue?vue&type=template&id=535fce74&"
import script from "./zPayPaymentCheckbox.js?vue&type=script&lang=js&"
export * from "./zPayPaymentCheckbox.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports